<sw-page class="moorl-demo-data-index">
    <template #content>
        <sw-card-view>
            <mt-card
                :isLoading="isLoading"
                :title="$tc('moorl-demo-data.name')"
            >
                <template v-if="options.length">
                    <sw-single-select
                        :label="$tc('moorl-foundation.field.type')"
                        v-model:value="optionIndex"
                        :options="options"
                    />
                    <sw-entity-single-select
                        :label="$tc('moorl-foundation.field.salesChannel')"
                        v-model:value="salesChannelId"
                        entity="sales_channel"
                    />
                    <mt-banner variant="attention">
                        {{ $tc('moorl-demo-data.notification') }}
                    </mt-banner>
                    <mt-switch
                        :label="$tc('moorl-demo-data.confirm')"
                        v-model="confirmed"
                    />
                    <mt-button
                        variant="primary"
                        :disabled="!acl.can('system.system_config') || !confirmed"
                        @click="install()"
                    >
                        {{ $tc('global.default.apply') }}
                    </mt-button>
                    <mt-button
                        variant="primary"
                        :disabled="!acl.can('system.system_config')"
                        @click="remove()"
                    >
                        {{ $tc('global.default.delete') }}
                    </mt-button>
                </template>

                <template v-else>
                    <mt-banner variant="attention">
                        {{ $tc('moorl-foundation.notification.demoDataNotFound') }}
                    </mt-banner>
                </template>
            </mt-card>
        </sw-card-view>
    </template>
</sw-page>